import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { H3, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { Href } from "../../../Utils/Constants";
import { Link } from "react-router-dom";

const WelcomeBanner = () => {
  return (
    <Col xxl="4" xl="6" md="7" className="box-col-6">
      <Card className="profile-greeting">
        <CardBody>
          <div className="profile-greeting-details">
            <H3 className="f-w-600">Welcome Back, </H3>
            <div className="txt-secondary fs-4 f-w-600">Sade Parren</div>
            <P>
              You have completed 40% of your this day! Start a goal &amp;
              improve result.
            </P>
            <Link className="btn btn-primary" to={Href} target="blank">
              Get Started
              <i className="fa fa-angle-double-right mx-1" />
            </Link>
          </div>
          <Image className="img-fluid" src={dynamicImage(`dashboard/greeting.png`)} alt="image" />
        </CardBody>
        <div className="shap-block">
          <div className="rounded-shap">
            <i />
            <i />
            <i />
          </div>
        </div>
      </Card>
    </Col>
  );
};
export default WelcomeBanner;
